import * as TypeGraphQL from "type-graphql";
export var EventSnapshotScalarFieldEnum;
(function (EventSnapshotScalarFieldEnum) {
    EventSnapshotScalarFieldEnum["id"] = "id";
    EventSnapshotScalarFieldEnum["aggregateId"] = "aggregateId";
    EventSnapshotScalarFieldEnum["aggregateType"] = "aggregateType";
    EventSnapshotScalarFieldEnum["version"] = "version";
    EventSnapshotScalarFieldEnum["state"] = "state";
    EventSnapshotScalarFieldEnum["timestamp"] = "timestamp";
    EventSnapshotScalarFieldEnum["createdAt"] = "createdAt";
    EventSnapshotScalarFieldEnum["updatedAt"] = "updatedAt";
})(EventSnapshotScalarFieldEnum || (EventSnapshotScalarFieldEnum = {}));
TypeGraphQL.registerEnumType(EventSnapshotScalarFieldEnum, {
    name: "EventSnapshotScalarFieldEnum",
    description: undefined,
});
//# sourceMappingURL=EventSnapshotScalarFieldEnum.js.map